import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';

import { ButtonComponent } from '@/shared/ui-components/button/button.component';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [RouterModule, ButtonComponent, SvgIconComponent],
    template: `
        <main class="min-h-screen overflow-hidden bg-backgroundWhite px-6 py-6 sm:px-10 sm:py-8 flex flex-col">
            <header class="z-10 flex items-center justify-between shrink-0">
                <a routerLink="/" aria-label="BettaAlpha home">
                    <svg-icon src="/logos/logo-full.svg" svgClass="h-9 w-auto sm:h-11" />
                </a>
            </header>

            <section class="mx-auto flex max-w-3xl flex-col gap-(--spacing-layout-l) items-center pb-8 pt-8 text-center sm:pt-4 flex-1 justify-center">
                <svg-icon
                    src="/images/404.svg"
                    svgClass="h-auto w-full max-w-[560px]"
                    aria-label="404 page not found illustration"
                />

                <div class="flex w-full max-w-[340px] flex-col items-center">
                    <h1 class="text-heading-large text-headingText">Page Not Found</h1>
                    <p class="mt-3 text-body-large text-bodyText">
                        The page you’re looking for doesn’t exist<br class="hidden sm:block" />
                        or may have been moved.
                    </p>

                    <div class="mt-8 flex w-full flex-col gap-4">
                        <app-button
                            label="Go to Dashboard"
                            startIcon="/icons/dashboard.svg"
                            [fluid]="true"
                            (onClick)="goToDashboard()"
                        />
                    </div>
                </div>
            </section>
        </main>
    `,
})
export class Notfound {
    private readonly router = inject(Router);

    public goToDashboard(): void {
        void this.router.navigateByUrl('/');
    }
}
